//-----------------------------------
// featured-collection.js
// => theme/sections/featured-collection.liquid
//-----------------------------------

import $ from 'jquery';

/* DOM References
=====================================*/

/* Featured Collection Module
=====================================*/
export let carousels = {
    init() { 
        carousels.collectionSlider();
        carousels.categoriesSlider();
        carousels.reviewsSlider();
    },
    collectionSlider() {
        [].forEach.call(document.querySelectorAll('.glider'), function (ele) {
            new Glider(ele, {
                slidesToShow: 1.35,
                slidesToScroll: 1,
                draggable: true,
                dragVelocity: 1,
                duration: 1,
                arrows: {
                    prev: ele.parentNode.querySelector('.glider-prev'),
                    next: ele.parentNode.querySelector('.glider-next')
                },
                responsive: [
                    {
                    breakpoint: 1300,
                        settings: {
                            slidesToShow: 4.75,
                            slidesToScroll: 1
                        }
                    },
                    {
                    breakpoint: 1024,
                        settings: {
                            slidesToShow: 3.75,
                            slidesToScroll: 1
                        }
                    },
                    {
                    breakpoint: 768,
                        settings: {
                            slidesToShow: 2.75,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        });
    },
    categoriesSlider() {
        new Glider(document.querySelector('.category-glider'), {
            slidesToShow: 1.35,
            slidesToScroll: 1,
            draggable: true,
            dragVelocity: 1,
            duration: 1,
            arrows: {
                prev: '.glider-prev2',
                next: '.glider-next2'
            },
            responsive: [
                {
                breakpoint: 1300,
                    settings: {
                        slidesToShow: 4.75,
                        slidesToScroll: 1
                    }
                },
                {
                breakpoint: 1024,
                    settings: {
                        slidesToShow: 3.75,
                        slidesToScroll: 1
                    }
                },
                {
                breakpoint: 768,
                    settings: {
                        slidesToShow: 2.75,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    },
    reviewsSlider() {
        new Glider(document.querySelector('.reviews-glider'), {
            slidesToShow: 1.35,
            slidesToScroll: 1,
            draggable: true,
            dragVelocity: 1,
            duration: 1,
            arrows: {
                prev: '.glider-prev3',
                next: '.glider-next3'
            },
            responsive: [
                {
                breakpoint: 1300,
                    settings: {
                        slidesToShow: 4.75,
                        slidesToScroll: 1
                    }
                },
                {
                breakpoint: 1024,
                    settings: {
                        slidesToShow: 3.75,
                        slidesToScroll: 1
                    }
                },
                {
                breakpoint: 768,
                    settings: {
                        slidesToShow: 2.75,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }
}